module.exports = __webpack_public_path__ + "img/nav6.05de47be.png";